import { Breadcrumb,BreadcrumbItem } from "reactstrap";
import styles from  './Breadcrumb.module.scss'
import { Link, useLocation } from "react-router-dom";

export default function CustomBreadrumbs({id, title}) {
    const location = useLocation();
 
  return (
    <Breadcrumb>
        <BreadcrumbItem className={`${styles.lgtBreadcrumb}`} >
            <Link 
                to={'/'}
                >
                    <i className='bi bi-house'></i>
            </Link>
        </BreadcrumbItem>
        <BreadcrumbItem className={`${styles.lgtBreadcrumb}`} >
            <Link 
                to={`/product-list/${id && id}/${title && title.replace(/\s+/g, '-')}`}
                className={`${`/product-list/${id && id}/${title && title.replace(/\s+/g, '-')}` === location.pathname ? styles.active : ''}`}
                >
                    {title}
            </Link>
        </BreadcrumbItem>
  </Breadcrumb>
  )
}
